import React, { useContext, useEffect, useState } from "react";
import "./ProcessedRequest.css";
import { Button } from "../Buttons/Button/Button";

import messageIcon from "../../assets/messageIcon.svg";
import warningIcon from "../../assets/warningIcon.svg";
import emojiSadIcon from "../../assets/emojiSadIcon.svg";
import toolsIcon from "../../assets/toolsIcon.svg";
import {
  COMUNICATION_ERROR_SCREEN,
  HOME_SCREEN,
  MESSAGE_SENT_SCREEN,
  TRIES_ERROR_SCREEN,
  WRONG_NUMBER_SCREEN,
} from "../../constants/constants";
import Request from "../../services/Request";
import AppContext from "../../AppContext";
const api = new Request();

const ProcessedRequest = () => {
  const { screen, number, selectedProduct, setScreen, doCallTracking } =
    useContext(AppContext);

  const [responses] = useState({
    [MESSAGE_SENT_SCREEN]: {
      title: `Hemos enviado un SMS al número +1 ${number} para que pueda pagar el paquete que has solicitado.`,
      information:
        "Una vez que tu amigo o familiar realice el pago, recibirás un SMS que confirmará la compra.",
      icon: messageIcon,
      tracking: {
        printElementName: "IMPRESION_RESULTADO",
        buttonClickElementName: "CLIC_CONTINUAR",
        elementLocation: "PIDE_DATOS_Y_PAQUETES_RESULTADO_EXITOSO_",
      },
    },
    [TRIES_ERROR_SCREEN]: {
      title: "Número máximo de intentos",
      information:
        "Has superado el máximo de intentos permitido, prueba en 24 horas. ",
      icon: warningIcon,
      tracking: {
        printElementName: "IMPRESION_RESULTADO",
        buttonClickElementName: "CLIC_CONTINUAR",
        elementLocation: "PIDE_DATOS_Y_PAQUETES_MAX_INTENTOS_",
      },
    },
    [WRONG_NUMBER_SCREEN]: {
      title: "Celular incorrecto",
      information: "El celular introducido es incorrecto, prueba con otro.",
      icon: emojiSadIcon,
      tracking: {
        printElementName: "IMPRESION_RESULTADO",
        buttonClickElementName: "CLIC_CONTINUAR",
        elementLocation: "PIDE_DATOS_Y_PAQUETES_CELULAR_INCORRECTO_",
      },
    },
    [COMUNICATION_ERROR_SCREEN]: {
      title: "Error de comunicación",
      information:
        "Estamos teniendo dificultades para establecer conexión. Prueba en unos minutos por favor.",
      icon: toolsIcon,
      tracking: {
        printElementName: "IMPRESION_RESULTADO",
        buttonClickElementName: "CLIC_CONTINUAR",
        elementLocation: "PIDE_DATOS_Y_PAQUETES_ERROR_COMUNICACION_",
      },
    },
  });

  const handleOnClick = async () => {
    await doCallTracking(
      responses[screen]?.tracking?.buttonClickElementName,
      `${responses[screen]?.tracking?.elementLocation}${selectedProduct?.pkgType}_USA`,
      number
    );

    if (
      screen === WRONG_NUMBER_SCREEN ||
      screen === COMUNICATION_ERROR_SCREEN
    ) {
      const response = await api.getTries(number);
      const tries = parseInt(response.responseObject.attemptCounter);
      if (tries > 2) {
        window.location.replace("/dportal");
      } else {
        setScreen(HOME_SCREEN);
      }
    } else {
      window.location.replace("/dportal");
    }
  };
  useEffect(() => {
    doCallTracking(
      responses[screen]?.tracking?.printElementName,
      `${responses[screen]?.tracking?.elementLocation}${selectedProduct?.pkgType}_USA`,
      number
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container__processed__request">
      <div className="processed__request__home__content">
        <div className="request__processed__card">
          <img src={responses[screen]?.icon} alt="response__icon" />
          <p className="response__title">{responses[screen]?.title}</p>
          <p className="response__info">{responses[screen]?.information}</p>
        </div>
      </div>

      <Button
        containerBtnStyles={"container__processed__request__button"}
        btnText={"Continuar"}
        btnStyles={"processed__request__button"}
        handleOnClick={handleOnClick}
      ></Button>
    </div>
  );
};

export default ProcessedRequest;
